/*
  wissen-klaviyo-formular.js
  Meldet ein Formular des Wissensbereichs ueber Klaviyos Client-API an, ohne
  dass der Besucher die Seite verlaesst.

  Geprueft am 31.08.2026 direkt von hpn-store.de aus, nicht aus der Doku
  abgeschrieben:
  - CORS von hpn-store.de gegen a.klaviyo.com/client/subscriptions geht durch,
    Klaviyo antwortet mit sauberem JSON statt mit einem Verbindungsabbruch.
  - Der oft zitierte Aufbau mit "profiles" im Plural wird abgelehnt:
    'profiles' is not a valid field for the resource 'subscription'.
    Richtig ist "profile" im Singular.
  - first_name, properties und subscriptions werden angenommen. Im Test blieb
    als einzige Beanstandung die fehlende E-Mail.
  - Die Kopfzeile revision traegt 2026-04-15. Ein Datum in der Zukunft gibt
    404 "Unable to specify a future revision date".

  company_id ist der oeffentliche Schluessel des Kontos und darf im Quelltext
  stehen. Ein privater Schluessel gehoert NIEMALS in den Browser.

  Doppeltes Opt-in: Klaviyo schickt sofort die Bestaetigungsmail. Erst nach
  dem Klick wird die Person Mitglied der Liste, und erst dann startet der
  Flow. Der Anmeldezeitpunkt ist also nicht der Flow-Zeitpunkt.
*/
(function () {
  'use strict';

  var ENDPUNKT = 'https://a.klaviyo.com/client/subscriptions';
  var REVISION = '2026-04-15';

  function melden(form, text, art) {
    var hinweis = form.querySelector('[data-hinweis-feld]');
    if (!hinweis) return;
    hinweis.hidden = false;
    hinweis.textContent = text;
    hinweis.setAttribute('data-art', art);
    hinweis.setAttribute('role', art === 'fehler' ? 'alert' : 'status');
  }

  function nutzlast(form) {
    var d = form.dataset;
    var vorname = form.querySelector('[name="vorname"]');
    var eigenschaften = {
      src_last_touch: d.quelle || 'wissen',
      consent_source: d.einwilligungsquelle || 'wissen'
    };
    if (d.magnet) eigenschaften.lead_magnet_last = d.magnet;
    if (d.interesse) eigenschaften.interessen = [d.interesse];

    var profil = {
      email: form.querySelector('[name="email"]').value.trim(),
      properties: eigenschaften,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (vorname && vorname.value.trim()) profil.first_name = vorname.value.trim();

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: d.custom_source || 'Wissensbereich',
          profile: { data: { type: 'profile', attributes: profil } }
        },
        relationships: { list: { data: { type: 'list', id: d.liste } } }
      }
    };
  }

  function anbinden(form) {
    if (form.dataset.gebunden === '1') return;
    form.dataset.gebunden = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knopf = form.querySelector('button[type="submit"]');

      /* Ohne Listen-Kennung wird gar nichts geschickt. Sonst liefe die
         Anmeldung ins Leere und der Besucher saehe trotzdem eine
         Erfolgsmeldung. */
      if (!form.dataset.liste) {
        melden(form, form.dataset.textFehler, 'fehler');
        return;
      }

      if (knopf) knopf.disabled = true;
      melden(form, form.dataset.textLaeuft || 'Einen Moment.', 'laeuft');

      fetch(ENDPUNKT + '?company_id=' + encodeURIComponent(form.dataset.konto), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(nutzlast(form))
      })
        .then(function (r) {
          if (r.ok) {
            melden(form, form.dataset.textErfolg, 'erfolg');
            form.reset();
          } else {
            melden(form, form.dataset.textFehler, 'fehler');
          }
        })
        .catch(function () {
          melden(form, form.dataset.textFehler, 'fehler');
        })
        .finally(function () {
          if (knopf) knopf.disabled = false;
        });
    });
  }

  function start() {
    document.querySelectorAll('form[data-wissen-klaviyo]').forEach(anbinden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Der Theme-Editor tauscht Sections aus, ohne die Seite neu zu laden. */
  document.addEventListener('shopify:section:load', start);
})();
